import {
    QUEUED_CODE_RANGE,
    PROCESSING_CODE_RANGE,
    RETRYABLE_ERROR_CODE_RANGE,
    RECOVERABLE_ERROR_CODE_RANGE,
    RETRY_SEARCH_ERROR_CODE_RANGE,
    UNKNOWN_ERROR_CODE_RANGE,
} from '../../constants';

function _isQueuedStatus(statusCode) {
    return statusCode >= QUEUED_CODE_RANGE[0]
        && statusCode < QUEUED_CODE_RANGE[1];
}

function _isProcessingStatus(statusCode) {
    return statusCode >= PROCESSING_CODE_RANGE[0]
        && statusCode < PROCESSING_CODE_RANGE[1];
}

function _isRetryableErrorStatus(statusCode) {
    return statusCode >= RETRYABLE_ERROR_CODE_RANGE[0]
        && statusCode < RETRYABLE_ERROR_CODE_RANGE[1];
}

function _isRecoverableErrorStatus(statusCode) {
    return statusCode >= RECOVERABLE_ERROR_CODE_RANGE[0]
        && statusCode < RECOVERABLE_ERROR_CODE_RANGE[1];
}

function _isRetrySearchErrorStatus(statusCode) {
    return statusCode >= RETRY_SEARCH_ERROR_CODE_RANGE[0]
        && statusCode < RETRY_SEARCH_ERROR_CODE_RANGE[1];
}

function _isUnknownErrorStatus(statusCode) {
    return statusCode >= UNKNOWN_ERROR_CODE_RANGE[0]
        && statusCode < UNKNOWN_ERROR_CODE_RANGE[1];
}

function mapPollingStatus(data) {
    const { statusCode } = data;

    return {
        statusCode,
        status: data.status,
        message: data.message,
        isQueued: _isQueuedStatus(statusCode),
        isProcessing: _isProcessingStatus(statusCode),
        isRetryableError: _isRetryableErrorStatus(statusCode),
        isRecoverableError: _isRecoverableErrorStatus(statusCode),
        isRetrySearchError: _isRetrySearchErrorStatus(statusCode),
        isUnknownError: _isUnknownErrorStatus(statusCode),
    };
}

export {
    mapPollingStatus,
};
